import React from 'react';

import { addressFieldNames as fields } from '../address/addressModule';
import {
    defaultFieldProps,
    addressPropTypes
} from './addressFieldsModule';

import { fieldValidatorsIE } from './addressValidation';
import addressFields from './addressFieldMessages';
import {
    Street1Field,
    Street2Field,
    CityField,
    StateField,
    PostalCodeField
} from './Fields';


export const AddressFieldsIE = ({
    addressContext,
    cashbotName,
    doFieldValidation,
    intl,
    showUntouchedErrors,
    updateShippingAddress,
    validators,
    countryCode
}) => {
    const commonFieldProps = {
        addressContext,
        cashbotName,
        doFieldValidation,
        intl,
        showUntouchedErrors
    };
    const street1Props = {
        ...commonFieldProps,
        label: addressFields.IE.street1Label,
        updateShippingAddress,
        useAddressAutocomplete: false, 
        validate: validators.get(fields.ADDRESS_STREET1),
        countryCode
    };
    const street2Props = {
        ...commonFieldProps,
        validate: validators.get(fields.ADDRESS_STREET2),
        label: addressFields.IE.street2Label
    };
    const cityProps = {
        ...commonFieldProps,
        label: addressFields.IE.cityLabel,
        validate: validators.get(fields.ADDRESS_CITY)
    };
    const stateProps = {
        ...commonFieldProps,
        isRequiredField: false,
        doFieldValidation: false,
        label: addressFields.IE.stateLabel,
        validate: null
    };
    const postalCodeProps = {
        ...commonFieldProps,
        isRequiredField: false,
        doFieldValidation: false,
        label: addressFields.IE.postalCodeLabel,
        normalize: null,
        validate: null
    };

    return (
        <React.Fragment>
            <Street1Field {...street1Props} />
            <Street2Field {...street2Props} />
            <CityField {...cityProps} />
            <StateField {...stateProps} />
            <PostalCodeField {...postalCodeProps} />
        </React.Fragment>
    );
};

AddressFieldsIE.defaultProps = {
    ...defaultFieldProps,
    validators: fieldValidatorsIE
};

AddressFieldsIE.propTypes = {
    ...addressPropTypes
};

export default AddressFieldsIE;
